import React, { useState } from 'react';
import { useLanguage } from './LanguageContext';
import { API_URL } from '../utils/api';

const Signup = ({ onNavigate }) => {
  const { print_lang } = useLanguage();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/api/admin/signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          password: formData.password,
        }),
      });

      const data = await response.json();

      if (data.success) {
        setSuccess(true);
      } else {
        setError(data.message || 'Registration failed');
      }
    } catch (err) {
      setError('Connection error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-logo">
            <div className="auth-logo-icon" style={{ backgroundColor: '#10b981' }}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
            </div>
            <h1 className="auth-logo-title">{print_lang('common.success', 'Success')}!</h1>
            <p className="auth-logo-subtitle">{print_lang('auth.checkEmail', 'Please check your email for verification link')}</p>
          </div>

          <div className="alert alert-success">
            A verification email has been sent to <strong>{formData.email}</strong>.
            Please click the link in the email to activate your account.
          </div>

          <div className="auth-links">
            <a href="#login" onClick={(e) => { e.preventDefault(); onNavigate('login'); }}>
              {print_lang('auth.backToLogin', 'Back to Login')}
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-logo">
          <div className="auth-logo-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="8.5" cy="7" r="4" />
              <line x1="20" y1="8" x2="20" y2="14" />
              <line x1="23" y1="11" x2="17" y2="11" />
            </svg>
          </div>
          <h1 className="auth-logo-title">{print_lang('auth.signup', 'Sign Up')}</h1>
          <p className="auth-logo-subtitle">Create your admin account</p>
        </div>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label className="form-label">{print_lang('auth.name', 'Name')}</label>
            <input
              type="text"
              name="name"
              className="form-input"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Your name"
            />
          </div>

          <div className="form-group">
            <label className="form-label">{print_lang('auth.email', 'Email')}</label>
            <input
              type="email"
              name="email"
              className="form-input"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="admin@example.com"
            />
          </div>

          <div className="form-group">
            <label className="form-label">{print_lang('auth.password', 'Password')}</label>
            <input
              type="password"
              name="password"
              className="form-input"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="Minimum 6 characters"
            />
          </div>

          <div className="form-group">
            <label className="form-label">{print_lang('auth.confirmPassword', 'Confirm Password')}</label>
            <input
              type="password"
              name="confirmPassword"
              className="form-input"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
              placeholder="Re-enter password"
            />
          </div>

          <button type="submit" className="btn btn-primary btn-lg" style={{ width: '100%' }} disabled={loading}>
            {loading ? print_lang('common.loading', 'Loading...') : print_lang('auth.signup', 'Sign Up')}
          </button>
        </form>

        <div className="auth-links">
          <p>
            {print_lang('auth.hasAccount', 'Already have an account?')}{' '}
            <a href="#login" onClick={(e) => { e.preventDefault(); onNavigate('login'); }}>
              {print_lang('auth.login', 'Login')}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Signup;
